document.addEventListener('DOMContentLoaded', function () {
  // Animaciones al hacer scroll
  new WOW().init();

  // Fade out del video al terminar
  const bgvid = document.getElementById('bgvid');
  if (bgvid) {
    bgvid.addEventListener('ended', function () {
      bgvid.style.transition = 'opacity 0.6s ease';
      bgvid.style.opacity = 0;
    });
  }

  // Parallax
  let lastScrollTop = 0;
  window.addEventListener('scroll', function () {
    const st = window.scrollY;
    lastScrollTop = st;
    document.querySelectorAll('.js-parallax').forEach(function (el) {
      const start = el.offsetTop;
      const speedRatio = el.dataset.speedratio;
      const movement = st;
      el.style.backgroundPosition = `50% ${-(movement / speedRatio)}px`;
    });
  });

  // Dropdown toggle (Bootstrap, se mantiene si está incluido en el proyecto)
  // No es necesario traducir si estás usando Bootstrap, pero si lo deseas nativo, avísame.

  // SIDR en Vanilla JS (ejemplo simple de toggle sin displace)
 document.querySelectorAll('.js-toggle-menu').forEach(function (el) {
    el.addEventListener('click', function () {
      document.body.classList.toggle('sidr-open'); // personaliza esto según tu CSS
    });
  });
  // Video pause (comentado como en el original)
  /*
  document.querySelectorAll('.js-video-pause').forEach(function (el) {
    el.addEventListener('click', function () {
      const target = document.getElementById(el.dataset.target);
      target.pause();
    });
  });
  */

  // Activador de opciones
  document.body.addEventListener('click', function (e) {
    if (e.target.matches('.js-active')) {
      e.preventDefault();
      const href = e.target.getAttribute('href');
      const target = document.querySelector(href);
      const text = e.target.textContent;

      if (target) {
        target.parentElement.querySelectorAll('.option').forEach(el => {
          el.style.display = 'none';
        });
        target.style.display = 'flex';
        target.style.opacity = 0;
        setTimeout(() => target.style.opacity = 1, 50);
      }

      if (!e.target.classList.contains('js-formato')) {
        const btnGroup = e.target.closest('.btn-group');
        if (btnGroup) {
          const nombre = btnGroup.querySelector('.js-nombre');
          if (nombre) nombre.textContent = text;
        }
      }

      document.querySelectorAll('.dropdown-menu').forEach(menu => menu.classList.remove('show'));
    }
  });

  // Modal async
  document.body.addEventListener('click', function (e) {
    if (e.target.matches('.js-asyncmodal')) {
      e.preventDefault();
      const url = e.target.getAttribute('href');
      const targetSelector = e.target.dataset.target;
      const target = document.querySelector(targetSelector);

      fetch(url + '?async=true')
        .then(response => response.text())
        .then(result => {
          if (target) {
            const modal = new bootstrap.Modal(target);
            target.querySelector('.modal-legal').innerHTML = result;
            modal.show();

            document.querySelectorAll('.js-opencookies').forEach(el => {
              el.addEventListener('click', function () {
                const btn = document.querySelector('.ot-floating-button__open');
                if (btn) btn.click();
              });
            });
          }
        })
        .catch(() => {
          if (target) {
            const errorDiv = document.createElement('div');
            errorDiv.className = 'ajax-error text-center';
            errorDiv.textContent = 'Error';
            target.appendChild(errorDiv);
          }
        });
    }
  });

  // Tagging DataLayer push
  document.querySelectorAll('.js-datalayerpush').forEach(function (el) {
    el.addEventListener('click', function () {
      const data = {
        eventCategory: el.dataset.eventcategory,
        eventAction: el.dataset.eventaction,
        eventLabel: el.dataset.eventlabel,
        eventValue: el.dataset.eventvalue,
        eventInteraction: el.dataset.eventinteraction,
        event: el.dataset.event
      };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(data);
    });
  });

  // Pixel Facebook
  document.querySelectorAll('.js-pixelfacebook').forEach(function (el) {
    el.addEventListener('click', function () {
      const data = {
        pixel: el.dataset.pixel,
        pixelName: el.dataset.pixelname
      };
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(data);
    });
  });
});

// Función para pausar video incrustado
function toggleVideo(state) {
  const div = document.getElementById("popupVid");
  const iframe = div.getElementsByTagName("iframe")[0].contentWindow;
  iframe.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
}
